// composables/useNotificationSocket.js
import { onBeforeUnmount } from "vue";
import { io } from "socket.io-client";
import { useToastStore } from "@/components/helper/toast";
import { useNotificationStore } from "@/stores/useNotificationStore";

const SOCKET_PATH = "/api/socket.io";

const resolveSocketOrigin = () => {
  const apiUrl = import.meta.env.VITE_API_BASE_URL || "";

  try {
    const url = new URL(apiUrl, window.location.origin);
    const isLoopback =
      url.hostname === "localhost" || url.hostname === "127.0.0.1";
    const pageIsRemote =
      window.location.hostname !== "localhost" &&
      window.location.hostname !== "127.0.0.1";

    // Build production kadang masih bawa VITE_API_BASE_URL=localhost.
    // Browser user tidak bisa nyambung ke localhost server, jadi pakai origin halaman.
    if (isLoopback && pageIsRemote) {
      return window.location.origin;
    }

    return url.origin;
  } catch {
    return window.location.origin;
  }
};

export function useNotificationSocket() {
  const toastStore = useToastStore();
  const notificationStore = useNotificationStore();
  let socket = null;

  const initSocket = (userId) => {
    if (!userId) {
      console.warn("[WS] Missing userId, skipping connection");
      return;
    }

    if (socket) {
      socket.disconnect();
      socket = null;
    }

    const origin = resolveSocketOrigin();

    socket = io(`${origin}/notifications`, {
      path: SOCKET_PATH,
      query: { userId },
      // Polling dulu: di belakang nginx sering tidak ada header Upgrade,
      // jadi WebSocket murni gagal. Polling tetap HTTP biasa lewat /api.
      transports: ["polling", "websocket"],
      upgrade: true,
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
    });

    socket.on("connect", () => {});

    socket.on("toast-notification", (payload) => {
      toastStore.show({
        message: `${payload.title}: ${payload.description}`,
        type: payload.type,
        position: "top-right",
      });

      if (payload.id != null) {
        notificationStore.addNotifiedId(payload.id);
      }
    });

    socket.on("connect_error", (err) => {
      console.error("[WS] Connection error:", err.message);
    });

    socket.on("disconnect", (reason) => {
      console.log("[WS] Disconnected:", reason);
    });
  };

  onBeforeUnmount(() => {
    socket?.disconnect();
  });

  return { initSocket };
}
